import React from 'react';

function Shop({fill = 'currentColor', secondaryfill, strokewidth = 1, width = '1em', height = '1em', ...props}) {
	secondaryfill = secondaryfill || fill;

	return (
		<svg height={height} width={width} {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill} strokeLinecap="butt" strokeLinejoin="miter">
		<path d="m4,13v7c0,1.105.895,2,2,2h12c1.105,0,2-.895,2-2v-7" fill="none" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<path d="m21.874,7l-2.874-5H5l-2.874,5c.444,1.725,2.01,3,3.874,3,1.202,0,2.267-.541,3-1.38.733.839,1.798,1.38,3,1.38s2.267-.541,3-1.38c.733.839,1.798,1.38,3,1.38,1.864,0,3.43-1.275,3.874-3Z" fill="none" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<polyline fill="none" points="10 22 10 16 14 16 14 22" stroke={fill} strokeMiterlimit="10" strokeWidth={strokewidth}/>
	</g>
</svg>
	);
};

export default Shop;